import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ProductService } from 'modules/inventory/product/services';
import { PRODUCTS_LIST_KEY, PRODUCTS_WITH_STOCK_LIST_KEY } from 'modules/inventory/product/constants';

export const useDeleteProduct = (id: string, onClose: () => void, onRedirect?: boolean) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('product');
  const navigate = useNavigate();

  return useMutation(() => ProductService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [PRODUCTS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [PRODUCTS_WITH_STOCK_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
      if (onRedirect) {
        navigate('/inventory/products');
      }
    },
  });
};
